import React from "react";
import { useParams } from "react-router-dom";
import RiskDetailsView from "../../components/risks/RiskDetailsView";
import { spacing } from "../../ui/tokens";

export default function RiskDetailsPage() {
  const { riskId } = useParams();
  const parsedRiskId = Number(riskId);

  if (!Number.isInteger(parsedRiskId) || parsedRiskId <= 0) {
    return <div style={{ padding: spacing.lg * 2 }}>Invalid risk id.</div>;
  }

  return <RiskDetailsView riskId={parsedRiskId} mode="page" />;
}
